export default __webpack_public_path__ + "img/150DW.486b88f095a5d3d59632d2b37e7bf949.jpg";